// 관리자 설정
// 관리자
//
// @since 2018-07-31
// @Created By minsuk.Park <devp018>
// @Modified By jupil.Go <devp018>

import {i18n} from '~/plugins/i18n'
import {CmApiPrefix as apiPrefix} from '~/utils/restApi'

export const state = () => ({
  errorMessage: null,
  tmpData: {
    admin_cm_id: null
  },
  fndItemList: {
    admin_cm_id_list: ''
  },
  url: `${apiPrefix}/managers-cm`,
  selectedItem: {},
  adminDataList: [],
  adminPageData: {
    admin_cm_id: 0, // (integer): 관리자 통합 설정 아이디
    admin_cm_admin_name: '', // required 관리자 통합 설정 관리자 이름
    admin_cm_depart_name: '', // 관리자 통합 설정 부서 이름
    admin_cm_desc: '', // 관리자 통합 설정 설명
    admin_cm_device: [], // (Array[Inline Model 2], optional): 관리자 일반 통합 설정 장비 ,
    admin_cm_device_type: 1, // 관리자 통합 설정 장비 유형, 1 All, 2 장비 선택
    admin_cm_email: '', // 관리자 통합 설정 이메일, admin_cm_email_alarm_yn = 1 일 경우 필수
    admin_cm_email_alarm_yn: 1, // 관리자 통합 설정 이메일 알람 여부 0 false, 1 true
    admin_cm_id_expire_term: 30, // 관리자 통합 설정 계정 만료 기간
    admin_cm_id_expire_yn: 0, // 관리자 통합 설정 계정 만료 여부 0 false, 1 true
    admin_cm_level_type: 1, // 관리자 통합 설정 권한 유형 1 Level 1, 2 Level 2, 3 Level 3
    admin_cm_login_pw: '', // 관리자 통합 설정 로그인 패스워드
    admin_cm_login_uname: '', // 관리자 통합 설정 로그인 이름, 중복체크
    admin_cm_phone: '', // 관리자 통합 설정 전화번호
    admin_cm_pw_expire_yn: 0, // 관리자 통합 설정 비밀번호 만료 여부
    admin_cm_pw_expire_term: 60, // 관리자 통합 설정 비밀번호 만료 기간
    device_list_name: '',
    device_id: [], // 장비리스트, admin_cm_device_type = 2 일 경우 필수
    admin_ip_cm_use: 0,
    admin_ip_cm: []
  },
  deviceAdminData: [],
  tamsAdminIpList: []
})

export const mutations = {
  setErrorMessage (state, data) {
    const msg = _.isNil(data.msg) ? '' : {
      error: data.msg
    }
    state.errorMessage = msg
  },
  setAdminData (state, item) {
    // state.adminDataList = _cloneDeep(item)
    state.adminDataList = item.map(o => {
      const listLength = _.size(o.admin_cm_device)
      let
        list = [],
        listName = ''
      if (listLength > 0) {
        list = o.admin_cm_device.map(id => id.device_id)
        listName = (listLength > 1) ? i18n.t('cmn.deviceTypeText', {name: o.admin_cm_device[0].device_uname, cnt: listLength - 1}) : o.admin_cm_device[0].device_uname
      }
      return _.assign(o, { 'device_id': list, 'device_list_name': listName })
    })
  },
  setAdminCmId (state, id) {
    state.tmpData.admin_cm_id = Number(id)
  },
  addAdmin: (state, item) => {
    state.adminDataList.push(item)
  },
  setAdminDialog: (state, item) => {
    state.selectedItem = item
    state.adminPageData = _.cloneDeep(item)
    if (item.admin_cm_device_type === 1) { // 설정 장비 유형: ALL
      state.selectedItem.device_list_name = ''
      state.adminPageData.device_list_name = ''
    }
  },
  clearAdminDialog: (state) => {
    delete state.adminPageData.admin_cm_id
    state.adminPageData.admin_cm_level_type = 0 // required (one of 0, 1, 2) 관리자 유형(admin: 0, vs admin: 1, super admin: 2)
    state.adminPageData.admin_cm_login_uname = '' // required (string - maxLength: 32) 로그인 ID
    state.adminPageData.admin_cm_login_pw = '' // required (string - minLength: 9 - maxLength: 32) 비밀번호(Base64인코딩)(영문,숫자,특수문자 조합)
    state.adminPageData.admin_cm_admin_name = '' // required (string - maxLength: 32) 이름
    // state.adminPageData.pw_expire_use = 1 // required (one of 0, 1) 비밀번호 만료 사용(OFF: 0, ON: 1)
    state.adminPageData.admin_cm_pw_expire_term = 60 // required (integer - default: 60 - minimum: 1 - maximum: 120)비밀번호 만료 기간(일)
    state.adminPageData.admin_cm_level_type = 1 // required (one of 1, 2, 3) 권한(Level1: 1, vs Level2: 2, Level3: 3)
    state.adminPageData.admin_cm_depart_name = '' // (string - maxLength: 32) 부서
    state.adminPageData.admin_cm_phone = '' // (string - maxLength: 16) 연락처
    state.adminPageData.admin_cm_email = '' // (string - maxLength: 256) 이메일
    state.adminPageData.admin_cm_email_alarm_yn = 0 // required (one of 0, 1) 경고메일 수신 사용(OFF: 0, ON: 1)
    state.adminPageData.admin_cm_id_expire_yn = 0 // required (one of 0, 1) 계정 만료 사용(OFF: 0, ON: 1)
    state.adminPageData.admin_cm_id_expire_term = 30 // (integer - default: 30 - minimum: 1 - maximum: 90) 계정 만료 기간(일)
    state.adminPageData.admin_cm_device_type = 1 // 관리자 통합 설정 장비 유형, 1 All, 2 장비 선택
    state.adminPageData.device_list_name = ''
    state.adminPageData.admin_cm_desc = ''
    state.adminPageData.device_id = []
    state.adminPageData.admin_ip_cm_use = 0
    state.adminPageData.admin_ip_cm = []
    // state.adminPageData.admin_cm_device = ''
  },
  setDeviceAdminData: (state, payload) => {
    state.deviceAdminData = payload
  },
  initDeviceAdminData: (state) => {
    state.deviceAdminData = []
  },
  setTamsAdminIpList: (state, payload) => {
    state.tamsAdminIpList = payload
  },
  initTamsAdminIpList: (state) => {
    state.tamsAdminIpList = []
  }
}

export const actions = {
  async getAdminData ({commit, state}, isShowLoading = false) {
    let axiosParam = {}
    if (isShowLoading !== undefined && isShowLoading === false) {
      axiosParam = {loading: false}
    }
    const {code, result} = await this.$axios.$get(`${state.url}/0`, axiosParam)
    if (code === 'ok') {
      commit('setAdminData', result)
      return true
    }
    return false
  },
  async addEmptyAdmin ({commit, state}) {
    let res = {code: 'ok', result: {}}
    try {
      res = await this.$axios.$post(state.url, null, {loading: false, successAlert: false})
      if (res.code === 'ok') {
        commit('setAdminCmId', res.result.msg)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }

    return res
  },
  async addAdmin ({commit, dispatch, state}, param) {
    const admParam = _.cloneDeep(state.adminPageData)
    admParam.admin_cm_login_pw = btoa(param.password)
    delete admParam.device_list_name
    // delete admParam.admin_cm_pw_expire_yn
    const result2 = {}
    result2.error = null
    const {code, result} = await this.$axios.$post(`${state.url}/${state.tmpData.admin_cm_id}`, admParam)
    if (code === 'ok') {
      dispatch('getAdminData', false)
      if (!param.continued) {
        commit('clearAdminDialog')
      }
      return true
    }
    commit('setErrorMessage', result)
    return false
  },
  async edtAdmin ({commit, state}, password) {
    const param = _.cloneDeep(state.adminPageData)

    if (password.length !== 0) {
      param.admin_cm_login_pw = btoa(password)
    } else {
      param.admin_cm_login_pw = ''
    }
    state.tmpData.admin_cm_id = param.admin_cm_id
    delete param.admin_cm_type
    delete param.admin_login_uname
    delete param.admin_name
    delete param.cfg_admin_id
    delete param.cfg_dt
    delete param.admin_cm_device
    delete param.device_list_name
    delete param.itemIndex

    const {code, result} = await this.$axios.$post(`${state.url}/${state.tmpData.admin_cm_id}`, param, {alertMsg: i18n.t('msg.updateApply')})
    if (code === 'ok') {
      return true
    }
    commit('setErrorMessage', result)
    return false
  },
  async delAdmin ({commit, dispatch, state}, param) {
    const _findItemfilterAarray = _.map(param.idList.items, o => {
      return o.admin_cm_login_uname
    })
    const _fndItem = []
    _.map(state.adminDataList, k => {
      for (let i = 0; i < _findItemfilterAarray.length; i++) {
        if (_findItemfilterAarray[i] === k.admin_cm_login_uname) {
          _fndItem.push(k.admin_cm_id)
        }
      }
      return _fndItem
    })
    state.fndItemList.admin_cm_id_list = _fndItem
    const _findItemList = state.fndItemList
    const data = await this.$axios.$put(`${state.url}`, _findItemList, {alertMsg: i18n.t('msg.removeApply')})
    if (data.code === 'ok') {
      dispatch('getAdminData', false)
      return true
    }
    commit('setErrorMessage', data.result)
    return false
  },
  async getDeviceAdminData ({commit, state}, deviceId) {
    const deviceAdminApi = `${state.url}/device_admin/${deviceId}`
    let res = {code: 'ok', result: {}}
    try {
      res = await this.$axios.$get(deviceAdminApi, {loading: true, successAlert: false})
      if (res.code === 'ok') {
        commit('setDeviceAdminData', res.result)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async getTamsAdminIpList ({commit, state}) {
    const tamsAdminApi = `${state.url}-ip/0`
    let res = {code: 'ok', result: {}}

    try {
      res = await this.$axios.$get(tamsAdminApi, {loading: true, successAlert: false})
      if (res.code === 'ok') {
        commit('setTamsAdminIpList', res.result)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }

    return res
  },
  async finalCommand ({state}, type) {
    const apiUri = `${state.url}/${type}`,
      axiosConfig = (type === 'apply') ? { applyMsg: true } : { cancelMsg: true }

    const { code } = await this.$axios.$put(apiUri, void 0, axiosConfig)

    return code.toLowerCase() === 'ok'
  }
}

export const getters = {}

export const strict = false
